import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { googleClickRichTextEvent } from '../../../../../utils/analytics';
import InfoToolTip from '../../../../@shared/infoToolTip';
import { TLeftMostCellProps } from '../../../types/index.types';
import FormatText from './formatText';

const LeftMostCell: FC<TLeftMostCellProps> = (props): JSX.Element => {
  const { row, heading, eyebrow, searchTerm } = props;

  return (
    <>
      {row.title && (
        <FormatText
          text={row.title?.value as string}
          searchTerm={searchTerm}
          editable={true}
          extraClassName="rich-text"
          onClick={(event) => googleClickRichTextEvent(event, heading?.value ?? eyebrow?.value)}
        />
      )}
      <InfoToolTip className="model-detail-specification-table__info-icon" showIcon={Boolean(row.tooltip?.value)} width={300}>
        <div className="model-detail-specification-table__tooltip-wrapper">
          {row.tooltipTitle && (
            <RichText
              field={row.tooltipTitle}
              tag="h2"
              className="model-detail-specification-table__tooltip-title rich-text"
              editable={false}
            />
          )}
          {row.tooltip && (
            <RichText
              field={row.tooltip}
              tag="h2"
              className="model-detail-specification-table__tooltip-body rich-text"
              editable={false}
              onClick={(event) => googleClickRichTextEvent(event, heading?.value)}
            />
          )}
        </div>
      </InfoToolTip>
    </>
  );
};

export default LeftMostCell;
